import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/account/settings/')({
  component: () => (
    <div>
      <Navigate to='/account/settings/general' />
    </div>
  )
});
